import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const CreateAmountType = MatxLoadable({
    loader: () =>
        import ("./CreateAmountType")
})
const AllCreateAmountType= MatxLoadable({
    loader: () =>
        import ("./AllCreateAmountType")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const CreateAmountTypeRoutes = [
    {
        path: "/create_amount_type",
        component: AllCreateAmountType,
        // settings
    },

];

export default CreateAmountTypeRoutes;